module.exports = __webpack_public_path__ + "static/media/tnc.9346085a.png";